import TitleTip from "../common/Titletip";
import withWindowDimensions from "../shared/withWindowDimensions";
import { companyContacts } from "../../lib/constants/CompanyContacts";
import { trackClick } from "../../scripts/segment";
import { pageName } from "../../lib/utils/events_utils";
import Image from "next/image";
import { imageBasePath } from "lib/utils/imageUtils";

const WhatsappSection = ({ windowWidth }) => {
  const redirectToWhatsApp = () => {
    if (windowWidth > 767) {
      return `https://web.whatsapp.com/send?phone=${companyContacts.link.whatsApp}`;
    } else {
      return `https://api.whatsapp.com/send?phone=${companyContacts.link.whatsApp}`;
    }
  };

  const getIllustration = () => {
    if (windowWidth > 767) {
      return `${imageBasePath}/assets/images/new-landing-page/whatsapp_section.svg`;
    } else {
      return `${imageBasePath}/assets/images/new-landing-page/whatsapp_section_mobile.svg`;
    }
  };

  return (
    <div className="pt-12 pb-0 md:py-24 max-w-page-width mx-auto px-4 flex justify-between flex-wrap items-center">
      <div className="w-full md:w-3/5 pr-0 md:pr-10">
        <TitleTip text="Get to know us better" bgColor="#29BCB7" />
        <p className="text-22 md:text-5xl text-blue-950 font-bold pt-4">
          Say Hi to us on <span className="text-green-400">WhatsApp</span>
        </p>
        <p className="text-sm md:text-lg text-gray2-600 py-5">
          Connect with us on WhatsApp and get updates on education trends,
          financial advice, events, and more.
        </p>
        <div className="pt-5 md:pt-12">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={redirectToWhatsApp()}
            onClick={() => {
              trackClick(pageName.HOME_PAGE, {
                widgetName: "Get to know us better",
                widgetFormat: "Banner",
                contentName: "Connect with us",
                contentFormat: "Button",
              });
            }}
            className="bg-primary hover:bg-primaryLighter text-white text-center text-l py-2 md:py-4 px-8 rounded-sm font-bold flex justify-center items-center w-full md:w-2/5 cursor-pointer"
          >
            <Image
              src={`${imageBasePath}/assets/images/new-landing-page/whatsapp_icon.svg`}
              alt="whatsapp"
              width={29.07}
              height={29.07}
              className="max-w-full h-auto"
            />
            <span className="pl-4">Connect With Us</span>
          </a>
        </div>
      </div>
      <div className="w-full md:w-2/5 mt-6 md:mt-0">
        <Image
          src={getIllustration()}
          alt="Connect with us"
          width={windowWidth > 767 ? 447 : 358}
          height={windowWidth > 767 ? 302 : 133.65}
          className="max-w-full h-auto"
        />
      </div>
    </div>
  );
};

export default withWindowDimensions(WhatsappSection);
